import { render, staticRenderFns } from "./formScreenRejection.vue?vue&type=template&id=6814188e&scoped=true"
import script from "./formScreenRejection.vue?vue&type=script&lang=js"
export * from "./formScreenRejection.vue?vue&type=script&lang=js"
import style0 from "./formScreenRejection.vue?vue&type=style&index=0&id=6814188e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6814188e",
  null
  
)

export default component.exports